import { FeeReportForm } from "components";

export const FeeReportModal = () => {
  return <FeeReportForm />;
};
